export default "__VITE_ASSET__EWW5GmUq__"